export default (val) => typeof val === 'boolean';
